const ORDER_ASC = 'ASC'
const ORDER_DESC = 'DESC'

const OBJECT_STATS = new Map()
OBJECT_STATS.set('till salu', 1)
OBJECT_STATS.set('reserverad', 2)
OBJECT_STATS.set('bokad', 3)
OBJECT_STATS.set('såld', 4)



class SortBy {
    static byName(data, order = ORDER_ASC) {
        data.projekts.sort((a, b) => {
            return compareNames(a.name, b.name, order)
        })
        data.objekts.sort((a, b) => {
            return compareNames(a.name, b.name, order)
        })
        return data
    }

    static objektProjektNamn(data, order = ORDER_ASC) {
        data.objekts.sort((a, b) => {
            let i1 = a.props.projektNamn
                     ? a.props.projektNamn.toLowerCase()
                     : ''
            let i2 = b.props.projektNamn
                     ? b.props.projektNamn.toLowerCase()
                     : ''
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byPrice(data, order = ORDER_ASC) {
        data.projekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.minPrice)
            let i2 = Number.parseInt(b.props.minPrice)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        data.objekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.price)
            let i2 = Number.parseInt(b.props.price)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byStatus(data, order = ORDER_ASC) {
        function projektStatusSort(a, b) {
            if (a === 'pågående') {
                return -_resolve(order)
            } else if (b === 'pågående') {
                return _resolve(order)
            } else if (a === 'planerat') {
                return -_resolve(order)
            } else if (b === 'planerat') {
                return _resolve(order)
            } else if (a === 'kommande') {
                return -_resolve(order)
            } else if (b === 'kommande') {
                return _resolve(order)
            } else if (a === 'slutsålt') {
                return -_resolve(order)
            } else if (b === 'slutsålt') {
                return _resolve(order)
            }
        }

        data.projekts.sort((a, b) => {
            let i1 = a.props.status ? a.props.status.toLowerCase() : ''
            let i2 = b.props.status ? b.props.status.toLowerCase() : ''
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : projektStatusSort(i1, i2)
        })
        data.objekts.sort((a, b) => {
            let i1 = OBJECT_STATS.get(a.props.status ? a.props.status.toLowerCase() : '')
            let i2 = OBJECT_STATS.get(b.props.status ? b.props.status.toLowerCase() : '')
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byTilltrade(data, order = ORDER_ASC) {
        data.projekts.sort((a, b) => {
            let i1 = new Date(a.props.salesStartDate)
            let i2 = new Date(b.props.salesEndDate)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        data.objekts.sort((a, b) => {
            let i1 = new Date(a.props.salesStartDate)
            let i2 = new Date(b.props.salesEndDate)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byVaning(data, order = ORDER_ASC) {
        data.objekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.floor)
            let i2 = Number.parseInt(b.props.floor)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byArea(data, order = ORDER_ASC) {
        data.objekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.area)
            let i2 = Number.parseInt(b.props.area)
            return i1 === i2
                ? compareNames(a.name, b.name)
                : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byAvgift(data, order = ORDER_ASC) {
        data.projekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.minFee)
            let i2 = Number.parseInt(b.props.minFee)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        data.objekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.fee)
            let i2 = Number.parseInt(b.props.fee)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byRum(data, order = ORDER_ASC) {
        data.projekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.minRooms)
            let i2 = Number.parseInt(b.props.minRooms)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        data.objekts.sort((a, b) => {
            let i1 = Number.parseInt(a.props.rooms)
            let i2 = Number.parseInt(b.props.rooms)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        })
        return data
    }

    static byInflyttning(data, order = ORDER_ASC) {
        function getRating(property) {
            let st = property.props.salesText

            if (!st) {
                return 0
            }

            let year = 0

            try { year = Number.parseInt(st.match(/(\d+)/)[1]) + 1 } catch (e) { console.warn(e) }

            if (st.match(/h[oö]s(ten)?/i)) {
                year -= 0.01
            }
            if (st.match(/som(mar)?/i)) {
                year -= 0.03
            }
            if (st.match(/v[aå]r(en)?/i)) {
                year -= 0.05
            }
            if (st.match(/vin(tern)?/i)) {
                year -= 0.09
            }
            return year
        }

        function compare(a, b) {
            let i1 = getRating(a)
            let i2 = getRating(b)
            return i1 === i2
                   ? compareNames(a.name, b.name)
                   : i1 >= i2 ? _resolve(order) : -_resolve(order)
        }

        data.projekts.sort(compare)
        data.objekts.sort(compare)
        return data
    }
}

class SortMethod {
    constructor(args) {
        this.sortingFunction = args.sortingFunction
        this.direction = args.direction || ORDER_DESC
        this.name = args.name
    }

    execute(data) {
        return this.sortingFunction(data, this.direction)
    }

    reverse() {
        this.direction = this.direction === ORDER_ASC ? ORDER_DESC : ORDER_ASC
        return this
    }

    isASC() { return this.direction === ORDER_ASC }

    isDESC() { return this.direction === ORDER_DESC }
}


function _resolve(order) { return order === ORDER_ASC ? 1 : -1 }


function compareNames(name1, name2, order = ORDER_ASC) {
    return name1.toString().toLowerCase() >= name2.toString().toLowerCase() ? _resolve(order) : -_resolve(order)
}


const options = {
    inflyttning: new SortMethod({
        sortingFunction: SortBy.byInflyttning,
        name: 'Inflyttning',
    }),
    rum: new SortMethod({
        sortingFunction: SortBy.byRum,
        name: 'Rum',
    }),
    avgift: new SortMethod({
        sortingFunction: SortBy.byAvgift,
        name: 'Avgift',
    }),
    vaning: new SortMethod({
        sortingFunction: SortBy.byVaning,
        name: 'Våning',
    }),
    namn: new SortMethod({
        sortingFunction: SortBy.byName,
        name: 'Namn',
    }),
    objektProjektNamn: new SortMethod({
        sortingFunction: SortBy.objektProjektNamn,
        name: 'Projekt Namn',
    }),
    status: new SortMethod({
        sortingFunction: SortBy.byStatus,
        name: 'Status',
    }),
    price: new SortMethod({
        sortingFunction: SortBy.byPrice,
        name: 'Pris',
    }),
    area: new SortMethod({
        sortingFunction: SortBy.byArea,
        name: 'Yta',
    }),
}

const defaultOption = options.status.reverse()

export default { options, defaultOption }
